import React from "react";
import { motion } from "framer-motion";
import { Card, Form, Row, Col } from "react-bootstrap";
import SiteImageUpload from "./SiteImageUpload";
import IconLoader from "components/IconLoader/IconLoader";

const ImageSettings = ({ settings, updateImage, deleteImage }) => {
  const cardVariants = {
    initial: { scale: 1 },
    hover: { scale: 1.02, boxShadow: "0 10px 20px rgba(0,0,0,0.1)" },
    tap: { scale: 0.98 }
  };

  const imageTypes = [
    {
      type: "logo",
      label: "Logo",
      description: "Site logosu olarak kullanılır (PNG önerilir)",
      thumb: "/media/logos/logo-examy.png",
      size: "100x100"
    },
    {
      type: "register_form_banner",
      label: "Kayıt Formu Bannerı",
      description: "Kayıt formunda görünen banner görseli",
      thumb: "/media/register/registerTitleImage.png",
      size: "1140x135"
    },
    {
      type: "login_left_banner",
      label: "Giriş Sayfası Bannerı",
      description: "Giriş sayfasında sol tarafta görünen banner",
      thumb: "/media/register/sinavRegisterLogo.png",
      size: "800x800"
    },
    {
      type: "sinav_yonerge",
      label: "Sınav Yönergesi",
      description: "Sınav yönergesi belgesi",
      thumb: "/media/register/sinavYonerge.jpeg",
      size: "1979x2870"
    }
  ];

  const getSha1FieldName = (type) => {
    switch (type) {
      case "logo":
        return "logoSHA1";
      case "register_form_banner":
        return "registerFormBannerSHA1";
      case "login_left_banner":
        return "loginLeftBannerSHA1";
      case "sinav_yonerge":
        return "sinavYonergeUrlSHA1";
      default:
        return "";
    }
  };

  return (
    <motion.div
      initial={{ y: 40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.4 }}
    >
      <motion.div variants={cardVariants} initial="initial" whileHover="hover">
        <Card className="shadow-sm mb-0">
          <Card.Header className="bg-white py-3">
            <h5 className="mb-0">
              <IconLoader icon="mdiImageArea" className="me-2 text-primary" /> Görsel Ayarları
            </h5>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row>
                {imageTypes.map(({ type, label, description, thumb, size }) => (
                  <Col md={6} key={type} className="mb-4">
                    <div className="d-flex flex-column">
                      <SiteImageUpload
                        imageType={type}
                        label={label}
                        thumb={thumb}
                        sha1Value={settings?.[getSha1FieldName(type)] || ""}
                        onUpdate={updateImage}
                        onDelete={deleteImage}
                      />
                      <div className="form-text text-muted mt-3 text-center">{description}</div>
                      <div className="form-text text-muted mt-3 text-center">Boyut: {size}</div>
                      {settings?.[getSha1FieldName(type)] ? (
                        <div className="text-success text-center mt-2">
                          <i className="mdi mdi-check-circle me-1"></i> Yüklenmiş
                        </div>
                      ) : (
                        <div className="text-muted text-center mt-2">
                          <i className="mdi mdi-information-outline me-1"></i> Yüklenmemiş
                        </div>
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </motion.div>
    </motion.div>
  );
};

export default ImageSettings;
